const LOCAL_DEBUG = process.env.REACT_APP_LOCAL_DEBUG === 'true';
const DEBUG = process.env.REACT_APP_DEBUG === 'true';
const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const SERVER_WS = process.env.REACT_APP_SERVER_WS;
const API_KEY_FONT = process.env.REACT_APP_API_KEY_FONT_GOOGLE_FONTS;
const LOG_ROCKET_KEY = process.env.REACT_APP_LOG_ROCKET_KEY;
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

module.exports = {
    DEBUG: DEBUG,
    LOCAL_DEBUG: LOCAL_DEBUG,
    API_KEY_FONT: API_KEY_FONT,
    AUTH_TOKEN: null,
    authenticated: false,
    BASE_URL: `${SERVER_URL}/`,
    SERVER_URL: SERVER_URL,
    STATIC_URL: `${SERVER_URL}/static/`,
    BASE_URL2: SERVER_URL,
    MEDIA_URL: `${SERVER_URL}/media/`,
    WS_QUIPUU: SERVER_WS,
    LOG_ROCKET_KEY: LOG_ROCKET_KEY,
    SENTRY_DSN: SENTRY_DSN,
    WS_PRINTER: 'ws://127.0.0.1:1989/printer',

    TABLE_NO_DATA: {
        count: 2,
        next: false,
        number: 2,
        previous: false,
        results: [],
        total_pages: 2
    }
};


// WEBPACK FOOTER //
// ./src/data/globals.js